import { categories } from './categories';

export const articles = [
  {
    id: 1,
    title: '某千万粉丝网红被曝私生活混乱，多名前女友联合爆料',
    slug: 'qianwan-fensi-wanghong-beibao',
    excerpt: '近日，一位拥有超过千万粉丝的网红被多名前女友联合爆料，指控其私生活混乱、欺骗感情。这位网红以"清纯人设"走红，如今人设崩塌引发全网热议。据知情人士透露，该网红在私下与多位女性保持暧昧关系，甚至在同一时间与多人交往。',
    content: `
      <p>近日，一位拥有超过千万粉丝的知名网红被多名前女友联合爆料，指控其私生活混乱、欺骗感情。</p>
      <p>这位网红以"清纯阳光男孩"的人设走红网络，粉丝群体庞大，商业价值极高。然而，多位自称与其有过恋爱关系的女性在社交平台上联合发文，揭露了这位网红不为人知的另一面。</p>
      <h2>多位女性联合发声</h2>
      <p>据其中一位化名为"小雨"的女性透露，她与该网红交往期间，对方同时与其他多名女性保持暧昧关系。"他总是说自己在忙工作，实际上却是在和别的女生约会。"</p>
      <p>另一位爆料者"小美"则表示，该网红在交往过程中多次向她借钱，金额累计超过50万元，至今未还。"他说资金周转困难，我出于信任借给了他，结果现在电话不接微信不回。"</p>
      <h2>网红人设崩塌</h2>
      <p>这起爆料在网络上迅速发酵，相关话题阅读量已突破3亿。众多网友纷纷表示震惊，称"滤镜碎了一地"。</p>
      <p>截至目前，该网红尚未对此事做出公开回应，其工作室仅表示"正在核实相关信息"。</p>
    `,
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20silhouette%20of%20a%20person%20behind%20a%20smartphone%20screen%20with%20social%20media%20icons%20floating%2C%20warm%20dark%20red%20and%20charcoal%20tones%2C%20dramatic%20lighting%2C%20editorial%20photography%20style%2C%20moody%20atmosphere%2C%20clean%20minimal%20composition%2C%20soft%20gradient%20background%2C%20no%20text%2C%20high%20contrast&width=800&height=500&seq=article-bg-01&orientation=landscape',
    category: 'wanghong-heidiao',
    categoryName: '网红黑料',
    author: '吃瓜小编',
    date: '2026-06-30',
    views: 128500,
    comments: 3421,
    tags: ['网红', '人设崩塌', '感情纠纷', '千万粉丝'],
    featured: true,
    hot: true,
  },
  {
    id: 2,
    title: '知名女星深夜密会神秘男子，疑似新恋情曝光',
    slug: 'zhiming-nvxing-shenye-mihui',
    excerpt: '知名女演员李某被拍到深夜与一名神秘男子在高端餐厅共进晚餐，两人举止亲密，饭后一同返回某高档小区。这已是该女星今年第三次被拍到与异性约会，引发网友对其感情状况的猜测。',
    content: `
      <p>知名女演员李某近日被拍到深夜与一名神秘男子在高端餐厅共进晚餐，两人举止亲密，引发新恋情猜测。</p>
      <p>据目击者称，当晚11点左右，李某与一位身穿黑色西装的高大男子出现在某五星级酒店的餐厅。两人选择了一个较为隐蔽的角落位置，用餐期间有说有笑，气氛融洽。</p>
      <h2>饭后同返住所</h2>
      <p>用餐结束后，两人一同乘坐李某的私人座驾离开，最终驶入某高档小区的地下车库。据小区住户透露，李某在该小区拥有一处房产。</p>
      <h2>网友热议</h2>
      <p>消息传出后，网友们纷纷猜测这位神秘男子的身份。有人翻出李某近期的社交动态，发现她最近确实频繁暗戳戳地发一些"恋爱感"内容。</p>
      <p>截至目前，李某的工作室尚未对此事做出任何回应。</p>
    `,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20couple%20silhouette%20at%20a%20luxury%20restaurant%20with%20warm%20dim%20lighting%2C%20candlelight%20ambiance%2C%20soft%20bokeh%20background%2C%20mysterious%20and%20romantic%20atmosphere%2C%20editorial%20fashion%20photography%2C%20warm%20amber%20and%20deep%20brown%20tones%2C%20cinematic%20composition&width=800&height=500&seq=article-bg-02&orientation=landscape',
    category: 'yule-bagua',
    categoryName: '娱乐八卦',
    author: '八卦探长',
    date: '2026-06-29',
    views: 96500,
    comments: 2856,
    tags: ['女星', '恋情', '约会', '娱乐圈'],
    featured: true,
    hot: true,
  },
  {
    id: 3,
    title: '某品牌直播带货翻车，产品宣传与实际严重不符',
    slug: 'pinpai-zhibo-fanche-chanpin',
    excerpt: '某知名美妆品牌在直播带货过程中被消费者当场质疑，产品实际效果与宣传严重不符。主播现场试用后也出现尴尬一幕，直播评论区瞬间炸锅，品牌方紧急下播。',
    content: `
      <p>某知名美妆品牌近日在直播带货时遭遇"翻车"事件，产品宣传与实际效果严重不符引发众怒。</p>
      <p>据了解，该品牌在直播中主推一款号称"一抹即白"的美白精华液，宣称使用后立即见效。然而，当主播现场试用后，不仅没有出现宣传中的"瞬间提亮"效果，反而出现了搓泥、卡粉等尴尬情况。</p>
      <h2>消费者当场质疑</h2>
      <p>直播间的观众们很快发现了问题，弹幕瞬间被"翻车了""这也太假了吧"等评论刷屏。更有已购买该产品的消费者在评论区晒出使用对比图，直指产品虚假宣传。</p>
      <h2>品牌紧急下播</h2>
      <p>面对汹涌的质疑声，品牌方在直播进行到一半时紧急下播。目前该品牌官网已暂时关闭评论区，但相关话题已在各大社交平台登上热搜。</p>
    `,
    image: 'https://readdy.ai/api/search-image?query=Livestreaming%20studio%20setup%20with%20beauty%20products%20on%20a%20table%2C%20dramatic%20red%20warning%20lighting%2C%20chaotic%20atmosphere%2C%20smartphone%20showing%20angry%20comments%2C%20professional%20lighting%20equipment%20in%20background%2C%20warm%20coral%20and%20dark%20tones%2C%20editorial%20style&width=800&height=500&seq=article-bg-03&orientation=landscape',
    category: 'shipin-remen',
    categoryName: '视频热门',
    author: '直播观察员',
    date: '2026-06-28',
    views: 87500,
    comments: 5230,
    tags: ['直播带货', '翻车', '虚假宣传', '美妆'],
    featured: false,
    hot: true,
  },
  {
    id: 4,
    title: '惊天大反转！某企业家被举报案真相浮出水面',
    slug: 'jingtian-fanzhuan-qiyejia-zhenxiang',
    excerpt: '此前闹得沸沸扬扬的某知名企业家被举报一案迎来重大反转。多方证据显示举报内容存在大量不实信息，背后可能涉及商业竞争对手的恶意操作。',
    content: `
      <p>此前闹得沸沸扬扬的某知名企业家被举报一案迎来重大反转。</p>
      <p>经过数月调查，有关部门发现举报内容存在大量不实信息。据知情人士透露，举报者提供的部分"证据"存在明显的伪造痕迹，时间线也存在多处矛盾。</p>
      <h2>竞争对手恶意操作？</h2>
      <p>更令人震惊的是，调查人员发现举报背后可能涉及该企业家在行业内的主要竞争对手。有证据表明，竞争对手通过中间人向举报者提供了所谓的"内部资料"，而这些资料后来被证实是伪造的。</p>
      <h2>企业家发声</h2>
      <p>该企业家在最新声明中表示："真相终会大白。我相信法律的公正，也感谢所有在这段时间支持我的人。"</p>
    `,
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20courtroom%20or%20business%20scene%20with%20documents%20and%20scale%20of%20justice%20symbolism%2C%20warm%20golden%20light%20breaking%20through%20darkness%2C%20truth%20revealed%20concept%2C%20editorial%20photography%2C%20warm%20amber%20and%20deep%20brown%20tones%2C%20cinematic%20lighting&width=800&height=500&seq=article-bg-04&orientation=landscape',
    category: 'shetuan-redian',
    categoryName: '社会热点',
    author: '深度调查',
    date: '2026-06-27',
    views: 156000,
    comments: 8920,
    tags: ['企业家', '反转', '商业竞争', '真相'],
    featured: true,
    hot: true,
  },
  {
    id: 5,
    title: '短视频平台知名情侣博主被爆已分手，粉丝心碎一地',
    slug: 'qinglv-bozhu-fenshou-baoliao',
    excerpt: '以甜蜜情侣日常走红的短视频博主"甜甜圈CP"被爆已经分手数月。知情人透露两人因为长期异地和工作压力导致感情破裂，目前各自已有新欢。',
    content: `
      <p>以甜蜜情侣日常走红的短视频博主"甜甜圈CP"被爆已经分手数月。</p>
      <p>这对情侣博主在短视频平台上拥有超过800万粉丝，以分享甜蜜日常和情侣互动内容走红。然而近日有知情人爆料，两人其实已经在三个月前正式分手。</p>
      <h2>长期异地是主因</h2>
      <p>据知情人士透露，两人分手的主要原因是长期异地。男方因工作原因常年驻扎上海，而女方则留在北京发展。聚少离多加上工作压力，导致两人之间的矛盾逐渐累积。</p>
      <h2>各自已有新欢</h2>
      <p>更让粉丝心碎的是，爆料称两人目前各自已经有了新的交往对象。男方被拍到与一名时尚博主同行，而女方则被指与一位圈外人士关系密切。</p>
    `,
    image: 'https://readdy.ai/api/search-image?query=Broken%20heart%20symbolism%20with%20two%20silhouettes%20walking%20away%20from%20each%20other%2C%20warm%20sunset%20light%2C%20emotional%20atmosphere%2C%20split%20screen%20composition%2C%20soft%20pink%20and%20warm%20amber%20tones%2C%20cinematic%20style%2C%20clean%20background&width=800&height=500&seq=article-bg-05&orientation=landscape',
    category: 'wanghong-heidiao',
    categoryName: '网红黑料',
    author: '吃瓜小编',
    date: '2026-06-26',
    views: 112000,
    comments: 6540,
    tags: ['情侣博主', '分手', '网红', 'CP'],
    featured: false,
    hot: true,
  },
  {
    id: 6,
    title: '某选秀节目选手被曝学历造假，节目组紧急发声明',
    slug: 'xuanxiu-xuanshou-xueli-zaojia',
    excerpt: '热门选秀节目《星光闪耀》中人气选手张某被网友扒出学历造假，其声称的"某知名音乐学院在读"身份实际并不存在。节目组已紧急发布声明表示正在核实。',
    content: `
      <p>热门选秀节目《星光闪耀》中人气选手张某被网友扒出学历造假。</p>
      <p>张某在节目中一直以"某知名音乐学院在读生"的身份示人，凭借清秀外表和"学霸人设"收获了大量粉丝。然而近日有细心网友发现，该音乐学院的学生名单中并没有张某的名字。</p>
      <h2>网友深扒真相</h2>
      <p>经过网友们的进一步深扒，发现张某确实曾在该音乐学院的继续教育学院短期进修过，但并非全日制在校生。这与他在节目中营造的"专业音乐学院学霸"形象存在明显差距。</p>
      <h2>节目组回应</h2>
      <p>节目组在事件发酵后紧急发布声明，表示"正在与选手本人核实相关情况，将根据核实结果做出相应处理"。</p>
    `,
    image: 'https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20dramatic%20spotlight%20and%20a%20diploma%20or%20certificate%20being%20questioned%2C%20contrast%20between%20glamour%20and%20truth%2C%20warm%20golden%20spotlight%20on%20dark%20stage%2C%20editorial%20photography%2C%20dramatic%20composition&width=800&height=500&seq=article-bg-06&orientation=landscape',
    category: 'yule-bagua',
    categoryName: '娱乐八卦',
    author: '八卦探长',
    date: '2026-06-25',
    views: 143000,
    comments: 7890,
    tags: ['选秀', '学历造假', '人设', '综艺'],
    featured: false,
    hot: false,
  },
  {
    id: 7,
    title: '某地网红餐厅被曝光后厨卫生状况堪忧',
    slug: 'wanghong-canting-houchu-weisheng',
    excerpt: '一家在社交平台上走红的"网红餐厅"被前员工爆料后厨卫生状况极差，食材过期、蟑螂横行等问题触目惊心。市场监管部门已介入调查。',
    content: `
      <p>一家在社交平台上走红的"网红餐厅"被前员工曝光后厨卫生状况极差。</p>
      <p>这家餐厅以精致的摆盘和独特的口味在短短半年内迅速走红，吸引了大量食客前来打卡。然而，一位自称是该餐厅前员工的网友在社交平台发布了多段视频和照片，揭露了后厨令人震惊的卫生问题。</p>
      <h2>触目惊心的后厨</h2>
      <p>视频显示，后厨工作台上随意摆放着各种食材，部分肉类已经明显变色，冰箱内有大量过期调味料。更令人不安的是，画面中还出现了蟑螂的踪迹。</p>
      <h2>官方介入调查</h2>
      <p>事件曝光后，当地市场监管部门已经介入调查。该餐厅目前已被责令停业整顿，等待进一步处理结果。</p>
    `,
    image: 'https://readdy.ai/api/search-image?query=Dark%20chaotic%20commercial%20kitchen%20scene%20with%20red%20warning%20signs%2C%20dirty%20surfaces%2C%20contrast%20between%20beautiful%20food%20presentation%20and%20dirty%20kitchen%2C%20investigative%20journalism%20style%2C%20moody%20lighting%2C%20warm%20red%20accents%20on%20dark%20background&width=800&height=500&seq=article-bg-07&orientation=landscape',
    category: 'shetuan-redian',
    categoryName: '社会热点',
    author: '深度调查',
    date: '2026-06-24',
    views: 189000,
    comments: 12340,
    tags: ['网红餐厅', '食品安全', '后厨', '曝光'],
    featured: true,
    hot: false,
  },
  {
    id: 8,
    title: '某知名主播与平台闹翻，千万违约金引发行业震动',
    slug: 'zhubo-pingtai-weiyuejin-jiufen',
    excerpt: '某头部游戏主播因合约纠纷与直播平台对簿公堂，涉及违约金高达千万级别。该主播称平台存在拖欠薪资、虚假承诺等多项违约行为。',
    content: `
      <p>某头部游戏主播因合约纠纷与直播平台对簿公堂，涉及违约金高达千万级别。</p>
      <p>这位主播拥有超过500万粉丝，是平台游戏区的顶流之一。然而近半年来，该主播与平台之间的矛盾逐渐公开化，最终演变成了法律纠纷。</p>
      <h2>拖欠薪资与虚假承诺</h2>
      <p>据该主播方面透露，平台存在多项违约行为，包括长期拖欠直播薪资、未兑现签约时承诺的推广资源等。而平台方面则反指该主播违反独家直播协议，在其他平台进行直播。</p>
      <h2>行业震动</h2>
      <p>这起纠纷在直播行业引发了广泛关注。多位主播公开表示支持该主播维权，称直播平台的"霸王条款"问题由来已久。</p>
    `,
    image: 'https://readdy.ai/api/search-image?query=Gaming%20streamer%20setup%20with%20dramatic%20split%20lighting%2C%20one%20side%20bright%20and%20colorful%2C%20other%20side%20dark%20and%20tense%2C%20contract%20documents%20on%20a%20desk%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20editorial%20style%2C%20cinematic%20composition&width=800&height=500&seq=article-bg-08&orientation=landscape',
    category: 'zhibo-fanchez',
    categoryName: '直播翻车',
    author: '直播观察员',
    date: '2026-06-23',
    views: 76500,
    comments: 4320,
    tags: ['主播', '合约纠纷', '违约金', '直播平台'],
    featured: false,
    hot: false,
  },
  {
    id: 9,
    title: '素人美女参加综艺一炮而红，背后金主身份被扒',
    slug: 'suren-meinv-zongyi-jinzhu',
    excerpt: '某综艺节目中突然爆红的素人女嘉宾被网友扒出其背后有强大金主支持，其参赛资格和镜头资源分配引发争议。节目公平性遭受质疑。',
    content: `
      <p>某综艺节目中突然爆红的素人女嘉宾被网友扒出其背后有强大金主支持。</p>
      <p>这位女嘉宾在节目中凭借出众的外形和"清纯不做作"的表现迅速圈粉，获得了远超其他选手的镜头资源和关注度。然而，网友们的深扒让整个事情出现了转折。</p>
      <h2>金主身份曝光</h2>
      <p>据网友爆料，该女嘉宾与某知名投资公司高管关系密切。这位高管不仅为该综艺节目提供了赞助，还在节目播出期间动用资源为她进行大量营销推广。</p>
      <h2>节目公平性遭质疑</h2>
      <p>消息传出后，不少网友质疑节目的公平性："原来是带资进组，难怪镜头那么多。"节目组对此尚未做出回应。</p>
    `,
    image: 'https://readdy.ai/api/search-image?query=Reality%20TV%20show%20stage%20with%20golden%20spotlight%20on%20one%20person%2C%20other%20contestants%20in%20shadow%2C%20dramatic%20contrast%20lighting%2C%20money%20symbolism%20subtle%20in%20background%2C%20warm%20golden%20and%20dark%20tones%2C%20editorial%20photography&width=800&height=500&seq=article-bg-09&orientation=landscape',
    category: 'fancha-dagua',
    categoryName: '反差大瓜',
    author: '吃瓜小编',
    date: '2026-06-22',
    views: 135000,
    comments: 9870,
    tags: ['综艺', '素人', '金主', '内幕'],
    featured: false,
    hot: true,
  },
];

export const featuredArticles = articles.filter(a => a.featured);
export const hotArticles = articles.filter(a => a.hot);
export const latestArticles = [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

export function getArticleBySlug(slug: string) {
  return articles.find(a => a.slug === slug) || null;
}

export function getArticleById(id: number) {
  return articles.find(a => a.id === id) || null;
}

export function getArticlesByCategory(slug: string) {
  const cat = categories.find(c => c.slug === slug);
  return {
    category: cat || null,
    articles: articles.filter(a => a.category === slug),
  };
}
